{
  "allRequired": "Alle felt må fylles ut",
  "requiredField": "Må fylles ut",
  "optional": "Valgfritt",
  "allOptional": "Alle felt er valgfrie",
  "requiredRadiobuttonList": "Velg én",
  "requiredCheckboxList": "Velg én eller flere",
  "requiredSingleCheckbox": "Må velges"
}
